import React from "react";

const SlideSideStrut = ({ height, isLeft, color, sectionWidth, skip, isThreshold }) => {
    if (skip) return null;
    const x = (sectionWidth / 2 + 0.01) * (isLeft ? -1 : 1);
    const sHeight = isThreshold ? height + 0.13 : height + 0.15;
    const positionY = height / 2 - (isThreshold ? -0.003 : 0.01);
    return <mesh position={[x, positionY, 0]}><boxGeometry args={[0.02, sHeight, 0.2]} /><meshStandardMaterial color={color} /></mesh>;
  };

export default SlideSideStrut;